import { render, staticRenderFns } from "./ListLandfillsPlans.vue?vue&type=template&id=5c9f6308"
import script from "./ListLandfillsPlans.vue?vue&type=script&lang=js"
export * from "./ListLandfillsPlans.vue?vue&type=script&lang=js"
import style0 from "./ListLandfillsPlans.vue?vue&type=style&index=0&id=5c9f6308&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports